/**
 * The brand picker's choice survives a reload (2026-10-29 — it used to reset
 * to "All sites" on every one). Per viewer and per tenant. Storage can be
 * absent or throw (private window, blocked site data); the picker then simply
 * starts at "All sites". The layout drops a stored id the tenant no longer has.
 */

/** Indirection so a test can supply a throwing or absent storage. */
let storageImpl: () => Storage = () => window.localStorage;
export function setSiteStorageForTest(impl: () => Storage): void { storageImpl = impl; }

export const siteStorageKey = (companyId: string) => `intellitryx.siteId.${companyId}`;

export function readStoredSite(companyId: string): string | undefined {
  try { return storageImpl().getItem(siteStorageKey(companyId)) || undefined; } catch { return undefined; }
}

export function storeSite(companyId: string, siteId?: string): void {
  try {
    if (siteId) storageImpl().setItem(siteStorageKey(companyId), siteId);
    else storageImpl().removeItem(siteStorageKey(companyId));
  } catch { /* storage unavailable: the choice lasts until reload */ }
}
